module.exports = __webpack_public_path__ + "static/media/back.f3ad45e8.svg";